<template>
  <form class="search" @submit.prevent ref="searchForm">
    <label for="address" style="display: none">Address</label>
    <GmapAutocomplete id="address" @place_changed="input" :placeholder="placeholder" v-append-pac-here :selectFirstOnEnter="true" :value="locationAddress" class="search__input" ref="autocomplete" :options="autocompleteOptions"></GmapAutocomplete>
    <span type="submit" class="search-icon" @click="triggerEnter" aria-label="Search address or eircode">
      <fa-icon icon="search" class="search-icon__icon" aria-hidden="true"></fa-icon>
    </span>
  </form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { PLACE } from '@/enum/map-stat-types.enum';

export default {
  data () {
    return {
      autocompleteOptions: {
        componentRestrictions: {
          country: ['ie']
        }
      }
    }
  },
  computed: {
    ...mapGetters('map', ['locationAddress', 'technologyName', 'networkName',
      'location'])
  },
  props: ['placeholder'],
  methods: {
    ...mapActions('map', ['sendMapStat']),

    input(value) {
      if (!value) return;
      this.$emit('select', value);
      this.sendPlaceStats();
    },

    sendPlaceStats() {
      console.log('PLACE stat');
      this.sendMapStat({
        technology: this.technologyName,
        operator: this.networkName,
        lat: this.location && this.location.lat,
        lon: this.location && this.location.lng,
        address: this.location && this.location.address,
        placeId: this.location && this.location.placeId,
        type: PLACE
      });
    },

    triggerEnter() {
      let simulatedEvent = document.createEvent('HTMLEvents');
      simulatedEvent.initEvent('keydown', true, true);
      simulatedEvent.keyCode = 13;
      simulatedEvent.which = 13;
      this.$refs.autocomplete.$el.dispatchEvent(simulatedEvent);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import 'nib'

$searchHeight = 42px

.search
  row()
  width 100%
  relative top left
  height $searchHeight
  box-shadow 3px 3px 3px rgba(0,0,0, 0.16)
  box-sizing border-box
  &-icon
    notSelectable()
    clickable()
    square($searchHeight)
    animation none !important
    absolute top right
    background #018478
    border none
    padding 0
    &__icon
      square($searchHeight * 0.35)
      margin $searchHeight * 0.3
      color white
  &__input
    border 1px solid #666666
    border-radius 0
    padding-right $searchHeight * 1.1
    transition 0.15s box-shadow ease
    box-sizing border-box
    margin 0
    &::placeholder
      color #666666
    &:focus
      box-shadow 1px 1px 3px #ddd inset, -1px -1px 3px #ddd inset !important

</style>



// WEBPACK FOOTER //
// src/components/custom/SearchBar.vue